import { Users } from "@graylog/server-api";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
import CurrentUser from "logic/users/CurrentUser";
const convertPreferences = (preferences) => {
  const convertedPreferences = {};
  Object.entries(preferences).forEach(([key, value]) => {
    if (value === "true") {
      convertedPreferences[key] = true;
    } else if (value === "false") {
      convertedPreferences[key] = false;
    } else {
      convertedPreferences[key] = value;
    }
  });
  return convertedPreferences;
};
export const saveUserPreferences = (userName, preferences, callback = () => {
}, displaySuccessNotification = true) => {
  const convertedPreferences = convertPreferences(preferences);
  return Users.savePreferences(encodeURIComponent(userName), { preferences: convertedPreferences }).then(
    () => {
      if (displaySuccessNotification) {
        UserNotification.success(i18n.t("notifications.save_success", { ns: "users" }));
      }
      callback(preferences);
      CurrentUser.reload();
    },
    (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.save_failed", { ns: "users", userName, error: errorThrown }),
        i18n.t("notifications.save_failed_title", { ns: "users" })
      );
    }
  );
};
